import React from 'react';
import type { SectionMeta } from '../types/profile';
interface PageHeaderProps {
  section: SectionMeta;
  intro: string;
}
export function PageHeader({
  section,
  intro
}: PageHeaderProps) {
  return <header className="border-b border-slate-200 pb-10" data-id="element-26" data-mp="3revpf39onfvi">
      <div className="flex items-center gap-3" data-id="element-27" data-mp="3rcj6onw3p1he">
        <span className="font-serif text-sm text-gold-dark" data-id="element-28" data-mp="3mf98ojunbhhy">
          {section.index}
        </span>
        <span className="h-px w-8 bg-gold" aria-hidden="true" data-id="element-29" data-mp="2yqzw88jbo63h" />
        <span className="text-[11px] font-semibold uppercase tracking-overline text-slateink-light" data-id="element-30" data-mp="2tqvfqiiezbd9">
          {section.overline}
        </span>
      </div>
      <h1 className="mt-5 max-w-3xl font-serif text-3xl leading-tight text-navy sm:text-4xl" data-id="element-31" data-mp="38haxtofja377">
        {section.title}
      </h1>
      <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-slateink" data-id="element-32" data-mp="33n6pp1uj7p4j">
        {intro}
      </p>
    </header>;
}